// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS Marketplace Seller Reporting (AWS-MARKETPLACE)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmarketplacesellerreporting.html
 *
 * 2025-02-24T21:48:52.955Z
 */
export enum AwsAwsMarketplaceActions {
  /**
   * Grants permission to view a seller dashboard
   *
   * See https://docs.aws.amazon.com/marketplace/latest/userguide/dashboards.html#reports-accessing
   */
  GetSellerDashboard = 'aws-marketplace:GetSellerDashboard',
}
